import {Form} from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {memo, useCallback, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

import PhoneInput from '@/components/PhoneNumberField/PhoneInput';
import {PHONE_TYPES} from '@/components/PhoneNumberField/PhoneInput/constants';

const defaultValue = {type: PHONE_TYPES.MOBILE, phone: ''};

const PhoneEditor = ({value, onChange, haveType, limit, ...rest}) => {
  const {t} = useTranslation('common');
  const [phoneList, setPhoneList] = useState(value);
  
  useEffect(() => {
    if (!value || !value.length) {
      setPhoneList([Object.assign(defaultValue)]);
    } else
      setPhoneList(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  const addPhoneToList = useCallback(() => {
    phoneList.push({...defaultValue});
    setPhoneList([...phoneList]);
  }, [phoneList]);
  
  const notifyChange = useCallback((values) => {
    onChange && onChange([...values]);
  }, [onChange]);
  
  const onValueChange = useCallback((value, index) => {
    phoneList[index] = value;
    setPhoneList([...phoneList]);
    notifyChange([...phoneList]);
  }, [notifyChange, phoneList]);
  
  const onRemoveRequest = useCallback((index) => {
    phoneList.splice(index, 1);
    setPhoneList([...phoneList]);
    notifyChange(phoneList?.map(e => e));
  }, [notifyChange, phoneList]);
  
  return (
    <>
      {phoneList.map((phone, index) => <PhoneInput
        key={index}
        {...rest}
        {...phone}
        haveType={haveType}
        name={`phone-${index}`}
        canRemove={phoneList.length > 1 && index !== 0}
        onRemove={() => onRemoveRequest(index)}
        onChange={(e) => onValueChange(e, index)}
      />)}
      <div className={classNames('text-sm text-primary mt-2', {'hidden': phoneList?.length >= limit})}>
        <span onClick={addPhoneToList} className="cursor-pointer">{t('phoneAdd')}</span>
      </div>
    </>
  );
};

export default memo(PhoneEditor);

PhoneEditor.propTypes = {
  limit: PropTypes.number,
  value: PropTypes.array,
  haveType: PropTypes.bool,
  onChange: PropTypes.func
};

PhoneEditor.defaultProps = {
  value: [],
  limit: 4,
  haveType: true
};

// eslint-disable-next-line react/prop-types
export const renderPhoneEditor = ({formItemProps, field}) => {
  
  return (
    // eslint-disable-next-line react/prop-types
    <Form.Item {...formItemProps} required={field?.required}>
      <PhoneEditor {...field}/>
    </Form.Item>
  );
};
